import React, { useEffect } from "react";

import { DetailsContentContainer } from "../../styled/pickup";

import Progress from "../../common/progress";
import Requests from "../../common/requests";
import OrderMenu from "../../common/orderMenu";
import CustomerInfo from "../../common/customerInfo";
import MemberTel from "../../common/memberTel";
import PaymentType from "../../common/paymentType";

const DetailsContent = ({ selected }) => {
  useEffect(() => {
    console.log(selected);
  }, []);

  return (
    <DetailsContentContainer className={selected?.status}>
      {selected ? (
        <>
          <div className="pickupInfo">
            <span className="label">주문정보</span>
            <Progress selected={selected} />
          </div>
          <PaymentType paymentType={selected?.paymentType} />
          <MemberTel telNo={selected?.mberTel} />
          <Requests remark={selected?.reqTerm} />
          <OrderMenu products={selected?.products} selected={selected} />
          {selected.status !== "PICKUP" && <CustomerInfo selected={selected} />}
        </>
      ) : (
        <div className="notOrder">
          <div className="bg">선택된 주문이 없습니다.</div>
        </div>
      )}
    </DetailsContentContainer>
  );
};

export default DetailsContent;
